import lodash from 'lodash'
import { isLanguageFeature, loadLanguageAsync, langs } from '@/utils/i18n'
import types from '@/store/mutation-types'

const defaultState = {
  currentLanguage: langs.enUS,
  defaultSysLang: langs.enUS,
}

const getters = {
  defaultSysLang: state => state.defaultSysLang,
  currentLanguage: state => state.currentLanguage || state.defaultSysLang,
  currentUserDefaultLang (state, getters, rootState, rootGetters) {
    let langId = null
    let globalUser = rootGetters['user/currentGlobalUser']
    if (globalUser) {
      langId = lodash.get(globalUser, 'defaultLanguage.id')
    } else {
      langId = rootGetters['user/currentUser']['languageId']
    }
    return getters['regionLanguages'].find(option => parseInt(option.id) === parseInt(langId)) ||
      getters['regionLanguages'][0] ||
      getters['regionLanguages'].find(option => option.name === langs.enUS) || {}
  },
  regionLanguages (state, getters, rootState, rootGetters) {
    let langs = []
    rootGetters['regions/currentRegion']['features'].forEach(feature => {
      if (isLanguageFeature(feature.name)) {
        langs.push(feature)
      }
    })
    return langs
  },
}

const actions = {
  switchLang: async function ({ commit, getters }, lang) {
    lang = lang || getters.currentUserDefaultLang.name || langs.enUS
    await loadLanguageAsync(lang)
    commit(types.CURRENT_LANGUAGE, lang)
  },
}

const mutations = {
  [types.CURRENT_LANGUAGE] (state, lang) {
    state.currentLanguage = lang
  },
}

export default {
  namespaced: true,
  state: defaultState,
  getters,
  actions,
  mutations,
}
